import React from "react";

const markup = String.raw`<div class="card inline-style-33" id="vendDetailPanel">
<div class="card-head"><p class="card-title" id="vendDetailTitle">Detail</p><span class="reset-tag" onclick="vendCloseDetail()">Close ✕</span></div>
<div id="vendDetailBody"></div>
</div>`;

export default function VendorDetailDrilldown() {
  return (
    <div
      className="raw-fragment"
      dangerouslySetInnerHTML={{ __html: markup }}
    />
  );
}
